"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeChecker = void 0;
class TypeChecker {
    // #endregion Properties (1)
    // #region Public Static Accessors (1)
    static get instance() {
        return this._instance || (this._instance = new this());
    }
    // #endregion Public Static Accessors (1)
    // #region Public Methods (2)
    isHTMLCanvasElement(value) {
        return value instanceof HTMLCanvasElement;
    }
    isTypeOf(value, type) {
        return typeof value === type;
    }
}
exports.TypeChecker = TypeChecker;
//# sourceMappingURL=TypeChecker.js.map